export const effectiveOutstanding = (invoice) => Number(invoice?.saldo_efectivo ?? invoice?.saldo ?? 0);

export function groupDashboardByCurrency(dashboard = {}) {
  const groups = dashboard.deuda_por_moneda || dashboard.por_moneda || dashboard.monedas || {};
  if (Array.isArray(groups)) return groups.map((item) => ({ ...item, moneda: item.moneda || item.currency || 'ARS' }));
  return Object.entries(groups).map(([moneda, values]) => ({ moneda, ...values }));
}

export function allocationFor(invoice, amount = effectiveOutstanding(invoice)) {
  return { comprobante_id: invoice.id, importe_aplicado: Math.min(Number(amount), effectiveOutstanding(invoice)), moneda: invoice.moneda || 'ARS' };
}

export function discrepancyLabel(invoice) {
  const difference = Number(invoice?.desvio_saldo || 0);
  return Math.abs(difference) < 0.005 ? '' : `Desvío de saldo: ${new Intl.NumberFormat('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(difference)}`;
}

export function balancedSubmit({ proveedorId, proveedor_id, moneda, comprobantes = [], medios = [], retenciones = [] }) {
  if (!(proveedorId || proveedor_id) || !moneda || !comprobantes.length) return false;
  if (comprobantes.some((item) => item.moneda && item.moneda !== moneda)) return false;
  const sum = (items) => items.reduce((total, item) => total + Number(item.importe_aplicado ?? item.importe ?? 0), 0);
  const documents = sum(comprobantes);
  const payment = sum(medios) + sum(retenciones);
  return Number.isFinite(documents) && documents > 0 && Math.abs(documents - payment) <= 0.01;
}
